/**
 * Kurul karşılaştırmalı puanlama — konuya göre esnek ağırlık + el kaldırma oyları.
 * Kriter ortalaması = Σ(puan × oy) / katılanÜye
 * Nihai /100 = Σ((kriterOrt / 5) × konuAğırlığı%)
 */
import { BOARD_CRITERIA } from './odulOneriCriteria'

export const CRITERION_COUNT = BOARD_CRITERIA.length
export const MAX_SCORE_PER_CRITERION = 5
export const MAX_WEIGHTED_SCORE = 100

/** topic → { yenilik, kalite, verimlilik, isg, yayginlastirma } ağırlık % (toplam 100) */
export const TOPIC_WEIGHT_PROFILES = {
  'İş Sağlığı ve Güvenliği (İSG)': {
    yenilik: 15,
    kalite: 0,
    verimlilik: 0,
    isg: 70,
    yayginlastirma: 15,
  },
  'İş Kolaylaştırma / Ergonomi': {
    yenilik: 15,
    kalite: 0,
    verimlilik: 20,
    isg: 50,
    yayginlastirma: 15,
  },
  'Kalite Artışı & Hurda Azaltma & Hata Önleme': {
    yenilik: 15,
    kalite: 50,
    verimlilik: 20,
    isg: 0,
    yayginlastirma: 15,
  },
  'Üretim Süreçlerinin İyileştirilmesi (Zaman Tasarrufu)': {
    yenilik: 15,
    kalite: 0,
    verimlilik: 70,
    isg: 0,
    yayginlastirma: 15,
  },
  'Ekipman & Makine Verimliliği (OEE)': {
    yenilik: 15,
    kalite: 20,
    verimlilik: 50,
    isg: 0,
    yayginlastirma: 15,
  },
  'Maliyet Azaltma Önerileri': {
    yenilik: 15,
    kalite: 0,
    verimlilik: 70,
    isg: 0,
    yayginlastirma: 15,
  },
  'Enerji Tasarrufu ve Verimlilik': {
    yenilik: 15,
    kalite: 0,
    verimlilik: 70,
    isg: 0,
    yayginlastirma: 15,
  },
  'Çevre Koruma & Sürdürülebilirlik': {
    yenilik: 15,
    kalite: 0,
    verimlilik: 70,
    isg: 0,
    yayginlastirma: 15,
  },
  'İnovasyon ve Ürün Geliştirme': {
    yenilik: 30,
    kalite: 30,
    verimlilik: 25,
    isg: 0,
    yayginlastirma: 15,
  },
  'Saha Düzeni & Görsellik (5S)': {
    yenilik: 15,
    kalite: 15,
    verimlilik: 30,
    isg: 25,
    yayginlastirma: 15,
  },
  // OPEX ACTUAL_BENEFIT_AREAS ile aynı anahtar
  'Genel İyileştirme Önerileri': {
    yenilik: 20,
    kalite: 20,
    verimlilik: 20,
    isg: 20,
    yayginlastirma: 20,
  },
}

const DEFAULT_WEIGHTS = TOPIC_WEIGHT_PROFILES['Genel İyileştirme Önerileri']

/** Eski "Diğer" / yeni fayda alanı anahtarları */
const TOPIC_ALIASES = {
  Diğer: 'Genel İyileştirme Önerileri',
}

const normalizeTopicKey = (topic) => {
  const key = String(topic || '').trim()
  return TOPIC_ALIASES[key] || key
}

/** Konu → karşılaştırmalı kurul grubu (HTML prototip POLICIES.group) */
export const TOPIC_SCORING_GROUPS = {
  'İş Sağlığı ve Güvenliği (İSG)': 'İSG ve Ergonomi',
  'İş Kolaylaştırma / Ergonomi': 'İSG ve Ergonomi',
  'Kalite Artışı & Hurda Azaltma & Hata Önleme': 'Kalite ve Hata Önleme',
  'Üretim Süreçlerinin İyileştirilmesi (Zaman Tasarrufu)': 'Verimlilik ve Maliyet',
  'Ekipman & Makine Verimliliği (OEE)': 'Verimlilik ve Maliyet',
  'Maliyet Azaltma Önerileri': 'Verimlilik ve Maliyet',
  'Enerji Tasarrufu ve Verimlilik': 'Enerji ve Çevre',
  'Çevre Koruma & Sürdürülebilirlik': 'Enerji ve Çevre',
  'İnovasyon ve Ürün Geliştirme': 'Yenilik ve Ürün Geliştirme',
  'Saha Düzeni & Görsellik (5S)': '5S ve Görsel Yönetim',
  'Genel İyileştirme Önerileri': 'Genel İyileştirme',
}

export const SCORING_GROUP_ORDER = [
  'İSG ve Ergonomi',
  'Kalite ve Hata Önleme',
  'Verimlilik ve Maliyet',
  'Enerji ve Çevre',
  'Yenilik ve Ürün Geliştirme',
  '5S ve Görsel Yönetim',
  'Genel İyileştirme',
  'Puanlama profili tanımsız',
]

export const getTopicWeights = (topic) => {
  const key = normalizeTopicKey(topic)
  return TOPIC_WEIGHT_PROFILES[key] || DEFAULT_WEIGHTS
}

export const getScoringGroup = (topic) => {
  const key = normalizeTopicKey(topic)
  return TOPIC_SCORING_GROUPS[key] || 'Puanlama profili tanımsız'
}

/** Gruptaki kayıtlarda ağırlığı >0 olan kriterler */
export const getActiveCriteriaForGroup = (groupName) => {
  const topics = Object.keys(TOPIC_SCORING_GROUPS).filter(
    (t) => TOPIC_SCORING_GROUPS[t] === groupName
  )
  return BOARD_CRITERIA.filter((c) =>
    topics.some((topic) => Number(getTopicWeights(topic)[c.id]) > 0)
  )
}

/** Konuya göre aktif (ağırlık > 0) kriterler */
export const getActiveCriteriaForTopic = (topic) => {
  const w = getTopicWeights(topic)
  return BOARD_CRITERIA.filter((c) => Number(w[c.id]) > 0).map((c) => ({
    ...c,
    weight: Number(w[c.id]) || 0,
  }))
}

export const getWeightsArray = (topic) => {
  const w = getTopicWeights(topic)
  return BOARD_CRITERIA.map((c) => Number(w[c.id]) || 0)
}

/**
 * @param {{ votesByScore: number[] }} criterionVote — votesByScore[0..5] = o puanı veren üye sayısı
 * @param {number} attendees
 */
export const criterionAverageFromVotes = (votesByScore, attendees) => {
  const n = Number(attendees) || 0
  if (n <= 0 || !Array.isArray(votesByScore)) return null
  const sumVotes = votesByScore.reduce((a, b) => a + (Number(b) || 0), 0)
  if (sumVotes !== n) return null
  const weighted = votesByScore.reduce(
    (acc, count, score) => acc + score * (Number(count) || 0),
    0
  )
  return Number((weighted / n).toFixed(4))
}

/**
 * @param {Array<number|null>} averagesByCriterion — her kriter 0–5 ort.
 * @param {string} topic
 * Ağırlığı 0 olan (kapsam dışı) kriterler skora dahil edilmez; ortalamaları null olabilir.
 */
export const getMeetingWeightedScore = (averagesByCriterion, topic) => {
  const weights = getWeightsArray(topic)
  if (!Array.isArray(averagesByCriterion) || averagesByCriterion.length !== CRITERION_COUNT) {
    return null
  }
  let total = 0
  let usedWeight = 0
  for (let i = 0; i < CRITERION_COUNT; i += 1) {
    const weight = Number(weights[i]) || 0
    if (weight <= 0) continue
    const avg = averagesByCriterion[i]
    if (avg == null || !Number.isFinite(Number(avg))) return null
    total += (Number(avg) / MAX_SCORE_PER_CRITERION) * weight
    usedWeight += weight
  }
  if (usedWeight <= 0) return null
  return Number(total.toFixed(4))
}

/** Kayıtlı kurul kararı + konu → /100 puan (eski null kayıtları da oylardan üretir) */
export const resolveBoardGroupScore = (boardDecision, topic) => {
  if (!boardDecision) return null
  const stored = boardDecision.groupScore
  if (stored != null && stored !== '' && Number.isFinite(Number(stored))) {
    return Number(stored)
  }
  const n = Number(boardDecision.attendees)
  const votes = boardDecision.votes
  const topicKey = topic || boardDecision.topic || ''
  if (!Array.isArray(votes) || !n || !topicKey) return null
  const activeIds = new Set(getActiveCriteriaForTopic(topicKey).map((c) => c.id))
  const averages = BOARD_CRITERIA.map((c, i) => {
    if (!activeIds.has(c.id)) return 0
    return criterionAverageFromVotes(votes[i], n)
  })
  return getMeetingWeightedScore(averages, topicKey)
}

export const formatWeightedScore = (value) =>
  Number(value || 0).toLocaleString('tr-TR', {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  })

/** votesByScore satırlarının toplam oyunun attendees ile uyumunu doğrular */
export const validateVoteRow = (votesByScore, attendees) => {
  if (!Array.isArray(votesByScore) || votesByScore.length !== 6) {
    return 'Her kriter için 0–5 puan oy sayıları girilmelidir.'
  }
  const n = Number(attendees)
  if (!Number.isFinite(n) || n < 1) return 'Katılan üye sayısı en az 1 olmalıdır.'
  const sum = votesByScore.reduce((a, b) => a + (Number(b) || 0), 0)
  if (sum !== n) {
    return `Oy toplamı (${sum}) katılan üye sayısına (${n}) eşit olmalıdır.`
  }
  return ''
}
